module.exports = __webpack_public_path__ + "img/check-circle.ce63c045.svg";